import React from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../assets/home/radiomonitor-site.jpg";
import { authFetch } from "../../authFetch";

const PUB = process.env.PUBLIC_URL + "/assets/home";
const roleOwner = `${PUB}/role-owner.svg`;
const roleProgram = `${PUB}/role-program.svg`;
const roleTech = `${PUB}/role-tech.svg`;
const rolePromo = `${PUB}/role-promo.svg`;
const roleSales = `${PUB}/role-sales.svg`;
const markGreen = `${PUB}/mark-green.svg`;
const presentationIcon = `${PUB}/icon_doc.svg`;
const arrowIcon = `${PUB}/arrow.svg`;
const moreLinkLayout = {
  stats: { marginTop: 32, display: "flex", justifyContent: "flex-end" },
  silence: { marginTop: 32, display: "flex", justifyContent: "flex-end" },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    color: "#006b44",
    fontSize: 16,
    fontWeight: 400,
    textDecoration: "none"
  },
  icon: { width: 19, height: 19, display: "block" }
};
const pricingStats = `${PUB}/pricing-stats.svg`;
const pricingMonitor = `${PUB}/pricing-monitor.svg`;
const presentationUaLink = 'https://docs.google.com/presentation/d/1klEjqc-XznF_S_W_qXHqp9MTijPwEgRwxdOim34cSsc/edit?usp=sharing';

const HERO_ROLES = [
  "власникам радіостанцій",
  "програмним директорам",
  "технічним директорам",
  "промослужбі радіостанції",
  "продавцям реклами",
];

const CLIENT_LOGOS = [
  process.env.PUBLIC_URL + "/assets/home/001_Logo_Rodynne.svg",
  process.env.PUBLIC_URL + "/assets/home/004_Logo_Prishepkin.svg",
  process.env.PUBLIC_URL + "/assets/home/003_Logo_Karamelka.svg",
  process.env.PUBLIC_URL + "/assets/home/004_Logo_Baba.svg",
];
const SUCCESS_FEATURES = [
  "Ефективне планування ефіру та рекламних блоків",
  "Прозорі дані для рекламодавців",
  "Чітка картина росту та лояльності аудиторії",
  "Гарантія, що ефір не зупиниться без вашого відома",
];
const FEATURE_DOT_SIZE = 20;
const FEATURE_DOT_COLOR = "#006b44";
const featureDotStyle = (size = FEATURE_DOT_SIZE) => ({
  width: size,
  height: size,
  borderRadius: 999,
  background: FEATURE_DOT_COLOR,
  display: "inline-block",
});

function ClientsCarousel() {
  const logos = CLIENT_LOGOS;
  const vis = 4;
  const step = 100 / vis;
  const [idx, setIdx] = React.useState(0);
  const [anim, setAnim] = React.useState(true);

  const track = React.useMemo(() => [...logos, ...logos.slice(0, vis)], [logos, vis]);

  React.useEffect(() => {
    const t = setInterval(() => setIdx((i) => i + 1), 3500);
    return () => clearInterval(t);
  }, [logos.length]);

  const onTransitionEnd = () => {
    if (idx >= logos.length) {
      setAnim(false);
      setIdx(0);
      setTimeout(() => setAnim(true), 20);
    }
  };

  const prev = () => {
    if (idx === 0) {
      setAnim(false);
      setIdx(logos.length);
      setTimeout(() => {
        setAnim(true);
        setIdx(Math.max(logos.length - 1, 0));
      }, 20);
    } else {
      setIdx((i) => i - 1);
    }
  };

  const next = () => setIdx((i) => i + 1);

  if (!logos.length) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, margin: "8px 0 14px" }}>
      <button
        type="button"
        onClick={prev}
        aria-label="Назад"
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "1px solid #cfd5d1",
          background: "#fff",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: "34px",
        }}
      >
        ‹
      </button>

      <div style={{ overflow: "hidden", flex: "1 1 auto" }}>
        <div
          onTransitionEnd={onTransitionEnd}
          style={{
            display: "flex",
            transform: `translateX(-${idx * step}%)`,
            transition: anim ? "transform 900ms ease" : "none",
            willChange: "transform",
          }}
        >
          {track.map((src, i) => {
            const isPrishepkin = src.includes("004_Logo_Prishepkin.svg");
            return (
              <div
                key={src + i}
                style={{
                  flex: `0 0 ${step}%`,
                  padding: "0 26px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                }}
              >
                <img
                  src={src}
                  alt=""
                  style={{
                    maxWidth: isPrishepkin ? 195 : 130,
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <button
        type="button"
        onClick={next}
        aria-label="Вперед"
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "1px solid #cfd5d1",
          background: "#fff",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: "34px",
        }}
      >
        ›
      </button>
    </div>
  );
}

export default function HomeUk({ isAuth }) {
  const [statsPriceRawUAH, setStatsPriceRawUAH] = React.useState(null);
  const [monitorPriceRawUAH, setMonitorPriceRawUAH] = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;
    Promise.all([
      authFetch("/products/STATS/price-uah").then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
      authFetch("/products/MONITORING/price-uah").then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
    ])
      .then(([stats, monitoring]) => {
        if (cancelled) return;
        setStatsPriceRawUAH(typeof stats?.price_uah === "number" ? stats.price_uah : null);
        setMonitorPriceRawUAH(typeof monitoring?.price_uah === "number" ? monitoring.price_uah : null);
      })
      .catch(() => {
        if (cancelled) return;
        setStatsPriceRawUAH(null);
        setMonitorPriceRawUAH(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const statsPriceUAH = React.useMemo(
    () => (typeof statsPriceRawUAH === "number" ? Math.ceil(statsPriceRawUAH) : null),
    [statsPriceRawUAH]
  );

  const monitorPriceUAH = React.useMemo(
    () => (typeof monitorPriceRawUAH === "number" ? Math.ceil(monitorPriceRawUAH) : null),
    [monitorPriceRawUAH]
  );

  return (
    <div
      style={{
        width: "100%",
        minHeight: 0,
        display: "flex",
        justifyContent: "center",
        paddingTop: 0,
        paddingBottom: "clamp(16px, 4vw, 32px)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1100,
          paddingTop: 0,
          paddingRight: "clamp(16px, 5vw, 48px)",
          paddingBottom: "clamp(16px, 5vw, 48px)",
          paddingLeft: "clamp(16px, 5vw, 48px)",
          boxSizing: "border-box",
          color: "#2e2e2e",
          lineHeight: 1.6,
          fontSize: 16,
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        }}
      >
        <img
          src={bannerImg}
          alt=""
          style={{ width: "100%", height: "auto", display: "block", marginBottom: 24 }}
        />
        {/* === Блок 1: Аналітика та моніторинг (герой + цільові ролі) === */}
        <section style={{ margin: "0 0 28px" }}>
          <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
            Аналітика та моніторинг для онлайн-радіо
          </h2>

          <p style={{ margin: "16px 0 10px", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> - сучасний сервіс для онлайн-радіостанцій, який об’єднує детальну статистику слухачів і
            цілодобовий технічний контроль ефіру
          </p>
          <p style={{ margin: "0 0 24px", fontSize: 18 }}>
            Отримуйте прозорі дані про свою аудиторію, доводьте рекламодавцям реальне охоплення та демонструйте ефективність
            рекламних блоків
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: 0,
              alignItems: "start",
              paddingTop: 8,
            }}
          >
            {HERO_ROLES.map((label, index) => (
              <div
                key={label}
                style={{
                  textAlign: "center",
                  padding: "0 24px",
                }}
              >
                <img
                  src={[roleOwner, roleProgram, roleTech, rolePromo, roleSales][index]}
                  alt={label}
                  style={{
                    width: 120,
                    height: 120,
                    display: "block",
                    margin: "0 auto 10px",
                    objectFit: "contain",
                  }}
                />
                <div style={{ color: "#006b44", fontWeight: 400 }}>{label}</div>
              </div>
            ))}
          </div>

          <p style={{ margin: "24px 0 0", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> - рішення для всіх, хто хоче знати все про своїх слухачів і бути впевненим у стабільності
            ефіру
          </p>
          <div
            style={{
              marginTop: 18,
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img
              src={presentationIcon}
              alt=""
              style={{ width: 22, height: 22 }}
              aria-hidden="true"
            />
            <a
              href={presentationUaLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#006b44",
                textDecoration: "none",
                fontSize: 18,
                fontWeight: 700,
              }}
            >
              Відкрити презентацію <span style={{ fontWeight: 800 }}>Radiomonitor.net</span>
            </a>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 2: Статистика слухачів інтернет-радіо === */}
        <section style={{ margin: "36px 0 16px" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 8px" }}>
            <Link to="service/stats#stats-hero" style={{ color: "inherit", textDecoration: "none", display: "inline-block" }}>
              Статистика слухачів інтернет-радіо
            </Link>
          </h2>
          <p style={{ margin: "0 0 16px", fontSize: 18 }}>
            Збирайте дані, які працюють на ваш бізнес. З <strong>Radiomonitor.net</strong> ви завжди знаєте, хто вас слухає і коли саме
          </p>
          <ul style={{ margin: 0, paddingLeft: 24, fontSize: 18 }}>
            <li>Кількість унікальних слухачів і підключень</li>
            <li>Географія та пристрої</li>
            <li>Пікові години та прайм-тайм</li>
            <li>TSL (середній час прослуховування)</li>
            <li>Нові слухачі, утримання та лояльність</li>
            <li>Топ-40 та статистика реклами</li>
          </ul>
          <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 28 }}>
            <img
              src={markGreen}
              alt=""
              style={{
                width: 72,
                height: 72,
                borderRadius: 8,
                flex: "0 0 auto",
                transform: "translateY(10px)",
              }}
            />
            <div style={{ fontSize: 18 }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>Додаткові можливості:</div>
              <div>- Відстеження кількості слухачів конкретного рекламного ролика</div>
              <div>- Автоматичне формування ТОП-40 пісень з ротації</div>
            </div>
          </div>
          <div style={moreLinkLayout.stats}>
            <Link to="service/stats#stats-hero" style={moreLinkLayout.link}>
              більше
              <img src={arrowIcon} alt="" style={moreLinkLayout.icon} />
            </Link>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 3: Цілодобовий контроль ефіру === */}
        <section style={{ margin: "36px 0 16px" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 8px" }}>
            <Link to="service/silence" style={{ color: "inherit", textDecoration: "none", display: "inline-block" }}>
              Цілодобовий контроль ефіру
            </Link>
          </h2>
          <p style={{ margin: "0 0 16px", fontSize: 18 }}>
            Ваш ефір завжди під контролем. <strong>Radiomonitor.net</strong> моніторить тишу і миттєво повідомляє про будь-які збої
          </p>
          <ul style={{ margin: 0, paddingLeft: 24, fontSize: 18 }}>
            <li>Контроль потоків (MP3 та AAC+) 24/7</li>
            <li>Миттєві сповіщення у Telegram</li>
            <li>Історія рівнів гучності за 7 днів</li>
          </ul>
          <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 28 }}>
            <img
              src={markGreen}
              alt=""
              style={{
                width: 72,
                height: 72,
                borderRadius: 8,
                flex: "0 0 auto",
                transform: "translateY(13px)",
              }}
            />
            <div style={{ fontSize: 18 }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>Переваги:</div>
              <div>- Просте підключення без додаткового обладнання</div>
              <div>- До 3 контактів для отримання повідомлень</div>
            </div>
          </div>
          <div style={moreLinkLayout.silence}>
            <Link to="service/silence" style={moreLinkLayout.link}>
              більше
              <img src={arrowIcon} alt="" style={moreLinkLayout.icon} />
            </Link>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 4: Слоган + 4 колонки переваг === */}
        <section style={{ margin: "40px 0 8px" }}>
          <h2
            style={{
              fontSize: 40,
              fontWeight: 900,
              color: "#006b44",
              margin: "0 0 27px",
              lineHeight: 1.2,
            }}
          >
            Radiomonitor.net -
            <br />
            все для успіху вашого онлайн-радіо
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 24,
              alignItems: "start",
              marginBottom: 12,
              textAlign: "center",
              fontWeight: 700,
              fontSize: 18,
            }}
          >
            {SUCCESS_FEATURES.map((text) => (
              <div
                key={text}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={featureDotStyle()} />
                <span>{text}</span>
              </div>
            ))}
          </div>
          <p style={{ margin: 0, fontSize: 18 }}>Станьте на крок попереду конкурентів вже сьогодні!</p>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 4.1: Карусель логотипів (клієнти) === */}
        <section style={{ margin: "32px 0 0" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 3px" }}>
            Radiomonitor.net
          </h2>
          <h3
            style={{
              fontSize: 40,
              fontWeight: 900,
              color: "#006b44",
              margin: "0 0 12px",
              lineHeight: 0.8,
            }}
          >
            обирають провідні онлайн-радіостанції
          </h3>

          <p style={{ margin: "0 0 18px", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> - міжнародний сервіс аналітики та моніторингу ефіру,
            яким вже користуються провідні онлайн-радіостанції. Ми допомагаємо
            інтернет-радіо з будь-якої країни світу отримувати точну статистику
            слухачів, прозорі дані для рекламодавців та гарантію стабільного ефіру
          </p>

          <ClientsCarousel />

          <p style={{ margin: 0, fontSize: 18 }}>
            Дуже хочемо бачити серед цих логотипів і вашу станцію! Приєднуйтесь
            до Radiomonitor.net з будь-якої точки світу
          </p>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 5: Цінові пакети === */}
        <section style={{ margin: "40px 0 0" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 24px" }}>
            Цінові пакети Radiomonitor.net
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 40,
              alignItems: "start",
              marginBottom: 24,
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={pricingStats}
                alt=""
                style={{ width: 160, height: 160, borderRadius: 12, marginBottom: 12 }}
              />
              <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 8 }}>Підписка на статистику*</div>
              <div style={{ fontWeight: 800, fontSize: 32, color: "#006b44" }}>
                {statsPriceUAH !== null ? `${statsPriceUAH.toLocaleString('uk-UA')} грн/місяць` : '— грн/місяць*'}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={pricingMonitor}
                alt=""
                style={{ width: 160, height: 160, borderRadius: 12, marginBottom: 12 }}
              />
              <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 8 }}>Підписка на моніторинг тиші**</div>
              <div style={{ fontWeight: 800, fontSize: 32, color: "#006b44" }}>
                {monitorPriceUAH !== null ? `${monitorPriceUAH.toLocaleString('uk-UA')} грн/місяць` : '— грн/місяць'}
              </div>
            </div>
          </div>
          <p style={{ margin: '12px 0 12px', fontSize: 14 }}>
            *Збір, збереження та обробка даних з одного потоку, 24/7, доступ до даних для 1 особи
            <br />
            **Спостереження за одним потоком, 24/7, користування чат-ботом 1+2 особи
          </p>
          <p style={{ margin: '12px 0 0', fontSize: 18 }}>
            Хочете спробувати? Залиште заявку або зареєструйте свою станцію вже зараз!
          </p>
        </section>
      </div>
    </div>
  );
}
